export function detectEnv(): 'local' | 'test' | 'prod' {
    if (typeof window === 'undefined') return 'local';
    const host = window.location.hostname.toLowerCase();

    // local dev
    if (host === 'localhost' || host === '127.0.0.1') return 'local';

    // test env
    if (host.includes('test')) {
        return 'test';
    }

    return 'prod';
}
